import { useQuery } from '@tanstack/react-query';

import backendService from '../services/backendService';

export const useSimilarGenerators = ({ generatorId }: { generatorId: string }) => {
  const { data, isFetching: isFetchingSimilarGenerators } = useQuery(
    ['similar-generators', generatorId],
    async () => {
      return backendService.instance.generators.listSimilarGenerators({
        generatorId,
      });
    },
    {
      staleTime: 1000 * 60 * 5,
      enabled: !!generatorId,
    },
  );

  return {
    similarGenerators: data || [],
    isFetchingSimilarGenerators,
  };
};
